import React, {useState, useEffect} from 'react'
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {isAuth} from "../../Utils/firebaseUtils";
import firebase from "firebase";
import TipCard from "./TipCard/TipCard";
import {MDBAlert, MDBCol, MDBRow} from "mdbreact";
import {Trans} from "react-i18next";
import classes from "../Homepage/Homepage.module.css";
import {SUPPORTED_FUNCTIONS} from "../../Utils/FunctionList";
import {Helmet} from "react-helmet";
import {returnTran} from "../../Utils/Trans";
const db = firebase.firestore()

const ListTips = (props) => {
    const [allArticle, setAllArticle] = useState([])
    const [isLoaded, setIsLoaded] = useState(false)
    const [noItem, setNoItem] = useState(false)
    const [isAdmin, setIsAdmin] = useState(false)


    useEffect(() => {
        if (isAuth(props.auth)) {
            firebase.auth().currentUser.getIdTokenResult()
                .then((idTokenResult) => {
                    setIsAdmin(idTokenResult.claims.type === "administrator")
                })
        }
    }, [props.auth])

    useEffect(() => {
        getArticles()
    }, [])

    const getArticles = () => {
        db.collection('Article')
            .limit(10)
            .get()
            .then(res => {
                if (!res.empty) {
                    let allItems = []
                    res.forEach(doc => {
                        allItems.push({
                            ...doc.data(),
                            id: doc.id
                        })
                    })
                    setAllArticle(allItems)
                    setIsLoaded(true)
                } else {
                    setNoItem(true)
                    setIsLoaded(true)
                }
            })
    }

    // if(isAdmin){
    //     return (
    //         <div>
    //
    //         </div>
    //     )
    // }
    // else if(isLoaded){
    return (
        <>
            <Helmet>
                <title> { returnTran("ListTips", "title")  + ' | MeWeSearcher | ' + returnTran("LeftNavBar", "description")}</title>
                {/*<meta property="fb:app_id" content="1293953327456577" />*/}
                <meta property="og:type" content="website" />
                <meta property="site_name" content="MeWeSearcher" />
                <meta property="title" content={ returnTran("ListTips", "title")  + ' | MeWeSearcher | ' + returnTran("LeftNavBar", "description")}/>
                <meta name="description" content={ returnTran("ListTips", "description")}/>
                <meta name="keywords" content={"mewe, search mewe, 找尋mewe群組, 香港mewe"}/>
                <meta property="og:title"
                      content={ returnTran("ListTips", "title")  + ' | MeWeSearcher | ' + returnTran("LeftNavBar", "description")}/>
                <meta property="og:description" content={ returnTran("ListTips", "description")}/>
                <meta property="og:url" content={"https://mewesearcher.com" + window.location.pathname}/>
                <meta property="og:site_name"
                      content={"MeWeSearcher | " + returnTran("LeftNavBar", "description")}/>
                {/*<meta property="og:updated_time"*/}
                {/*      content={new Date(this.state.article.lastModified.hasOwnProperty('seconds') ? this.state.article.lastModified.seconds * 1000 : this.state.article.lastModified._seconds * 1000 ).toISOString()}/>*/}
                <meta httpEquiv="content-language"
                      content={localStorage.getItem("i18n-lang") === "en" ? "en-us" : "zh-Hant"}/>
                <meta property="og:type" content="article"/>
                <meta property="og:image" content={"https://imgur.com/a/AMU0634"}/>
                <meta property="og:image:width" content="1280"/>
                <meta property="og:image:height" content="720"/>
                {/*<link rel="amphtml" href={"https://clipversity.com/amp/article/" + this.state.article.key}/>*/}
            </Helmet>
            <MDBRow>
                <MDBCol xl="12" lg="12" md="12" sm="12" xs="12">
                    <MDBAlert color={'info'} className={classes.Alert}>
                        <Trans>TipCard.alert</Trans>
                        <button className={classes.SuggestBtn}
                                onClick={() => {
                                    props.setModalController({
                                        type: SUPPORTED_FUNCTIONS.REPORT_MODAL,
                                        typeOfModal: SUPPORTED_FUNCTIONS.REPORT_MODAL,
                                        isModalOpen: true,
                                        metadata: {itemID: "suggestion"}
                                    })
                                }}
                        >
                            <Trans>ListCategory.suggest</Trans>
                        </button>
                    </MDBAlert>
                </MDBCol>
            </MDBRow>
            <MDBRow>
                <MDBCol xl="12" lg="12" md="12" sm="12" xs="12">
                    {
                        allArticle.map((a, index) => {
                            return (
                                <TipCard
                                    key={'tipcard' + index}
                                    data={a}
                                />
                            )
                        })
                    }
                </MDBCol>
            </MDBRow>

        </>
    )
    // }
    // else{
    //     return (
    //         <div>
    //
    //         </div>
    //     )
    // }

}
const mapDispatchToProps = dispatch => {
    return {
        setModalController: (state) => dispatch({
            type: state.type,
            typeOfModal: state.typeOfModal,
            isModalOpen: state.isModalOpen,
            metadata: state.metadata
        })
    }
}
const mapStateToProps = state => {
    return {
        auth: state.firebase.auth
    }

}

const enhance = connect(
    mapStateToProps,
    mapDispatchToProps
)


export default enhance(withRouter(ListTips))